import { FittedBedroomsEditDate } from '~/routes';
import { REVIEW_YOUR_DETAILS } from '~/components/review-details/your-details/review-your-details.config';
import { YOUR_DETAILS_FIELDS_REVIEW } from '~/components/review-details/your-details/you-details-fields-review.config';
import { msToAmPmHours } from '~/routes/utils';

export const config = {
  editMode: {
    EditDatePage: FittedBedroomsEditDate,
  },
  ReviewForm: {
    hideShopDetails: true,
    yourDetailsFields: [
      REVIEW_YOUR_DETAILS[0],
      REVIEW_YOUR_DETAILS[1],
      {
        term: 'Mobile number',
        fieldName: 'phoneNumber',
        fieldExtraProps: YOUR_DETAILS_FIELDS_REVIEW.mobileNumber,
      },
      REVIEW_YOUR_DETAILS[3],
    ],
    formatTimeSlot: time => (
      <span>
        {msToAmPmHours(time)}
      </span>
    ),
  },
};
